import { render, staticRenderFns } from "./PanelCompetitionMessagesSms.vue?vue&type=template&id=471c4708&scoped=true&"
import script from "./PanelCompetitionMessagesSms.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionMessagesSms.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionMessagesSms.vue?vue&type=style&index=0&id=471c4708&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c4708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471c4708')) {
      api.createRecord('471c4708', component.options)
    } else {
      api.reload('471c4708', component.options)
    }
    module.hot.accept("./PanelCompetitionMessagesSms.vue?vue&type=template&id=471c4708&scoped=true&", function () {
      api.rerender('471c4708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionMessagesSms.vue"
export default component.exports